module.exports = "/images/laser tag (flatten).svg?f6158eeda37cbb67bf74b0da3e5b1916";